import { render, staticRenderFns } from "./HeaderC.vue?vue&type=template&id=5e6d9a56&scoped=true"
import script from "./HeaderC.vue?vue&type=script&lang=js"
export * from "./HeaderC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6d9a56",
  null
  
)

export default component.exports